export { UPS_SIGNAL_FORMS_CONFIG } from './signal-forms.config';
